import { IKeHoachThucTapDoanhNghiepActionTypes } from "../../action-types/xet-thuc-tap/IKeHoachThucTapDoanhNghiepActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IKeHoachThucTapDoanhNghiepReducer } from "../../reducer-model/xet-thuc-tap/IKeHoachThucTapDoanhNghiepReducer";

const iniState: IKeHoachThucTapDoanhNghiepReducer = {
    status: eReducerStatusBase.is_not_initialization,
    isShowEditModal: false,
    keHoachThucTapDoanhNghieps: [],
}

export const keHoachThucTapDoanhNghiepReducer = (
    state: IKeHoachThucTapDoanhNghiepReducer = iniState,
    action: IKeHoachThucTapDoanhNghiepActionTypes // Replace with actual action type
): IKeHoachThucTapDoanhNghiepReducer => {
    switch (action.type) {
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_LOAD_BY_DOT_THUC_TAP_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_LOAD_BY_DOT_THUC_TAP_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                keHoachThucTapDoanhNghieps: action.payload
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_LOAD_BY_DOT_THUC_TAP_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                keHoachThucTapDoanhNghiepEdit: action.payload
            };
        case "KE_HOACH_THUC_TAP_DOANH_NGHIEP_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                keHoachThucTapDoanhNghiepEdit: undefined
            };
        default:
            return state;
    }
}